import MuiFormControl from '@material-ui/core/FormControl';
import MuiFormHelperText from '@material-ui/core/FormHelperText';
import MuiInputLabel from '@material-ui/core/InputLabel';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiSelect from '@material-ui/core/Select';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { HIGHLIGHT } from '../Colors';
import { BODY, MINI_HEADER } from '../Fonts';

const StyledDropdown = withStyles({
    root: {
        width: '100%',
        '& .MuiInputLabel-root': { // Label as placeholder
            font: BODY,
            color: '#94A2AB'
        },
        '& .MuiInputLabel-root.Mui-focused': { // Label on top focused
            color: HIGHLIGHT
        },
        '& .MuiInputLabel-root.Mui-error': { // Label error
            color: '#E52030'
        },
        '& .MuiInputLabel-shrink': { // Label on top 
            font: MINI_HEADER,
            transform: 'scale(1.0)'
        },
        '& .MuiInputBase-root': { // Input
            font: BODY,
            color: '#FFFFFF'
        },
        '& .MuiInput-input:focus': { // Input focused
            color: '#94A2AB'
        },
        '& .MuiSelect-icon': { // Input focused
            color: '#FFFFFF'
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#FFFFFF'
        },
        '& .MuiInput-underline:after': {
            borderBottom: '1px solid #FFFFFF'
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: '2px solid #FFFFFF'
        },
        '& .MuiInput-underline.Mui-focused:hover:not(.Mui-disabled):before': {
            borderBottomWidth: '1px'
        },
        '& .MuiInput-underline.Mui-error.Mui-focused:after': {
            borderBottom: `1px solid ${HIGHLIGHT}`
        },
        '& .MuiFormHelperText-root.Mui-error': {
            font: MINI_HEADER
        },
    }
})(MuiFormControl);

const StyledMenuItem = withStyles({
    root: {
        font: BODY,
        color: '#FFFFFF',
        '&.Mui-selected:hover': {
            backgroundColor: `${HIGHLIGHT} !important`
        },
        '&.Mui-selected': {
            backgroundColor: HIGHLIGHT
        }
    },
})(MuiMenuItem);

const useStyles = makeStyles({
    disabled: {
        opacity: 0.5
    },
    hidden: {
        display: 'none',
    }
});

interface DropdownProps {
    idProperty: string,
    valueProperty: string,
    selectedId: unknown,
    items: ReadonlyArray<any>,
    label: string,
    hidden?: boolean,
    disabled?: boolean,
    error?: boolean | string,
    autoFocus?: boolean,
    onChange?(item: any): void
}

export const Dropdown: React.FunctionComponent<DropdownProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';
    
    const getItem = (itemId: unknown): any => {
        return props.items.find(i => i[props.idProperty] === itemId);
    }

    const onChange = (itemId: unknown) => {
        const item = getItem(itemId);
        if (props.onChange) {
            props.onChange(item);
        }
    }

    const className = `${props.disabled ? classes.disabled : ''} ${props.hidden ? classes.hidden : ''}  ${stylingClassName}`;

    return (
        <StyledDropdown
            className={className}
            margin="dense"
            hidden={props.hidden}
            disabled={props.disabled}
            error={props.error ? true : false}>
            <MuiInputLabel>{props.label}</MuiInputLabel>
            <MuiSelect
                value={props.selectedId}
                onChange={v => onChange(v.target.value)}
                autoFocus={props.autoFocus}
                MenuProps={{ PaperProps: { style: { backgroundColor: '#151D24' } } }}>
                {props.items.map(v => <StyledMenuItem key={v[props.idProperty]} value={v[props.idProperty]}>{v[props.valueProperty]}</StyledMenuItem>)}
            </MuiSelect>
            <MuiFormHelperText>{typeof props.error === "string" ? props.error : null}</MuiFormHelperText>
        </StyledDropdown>
    );
}